export default {
	id: 'SIMPLE_PREMIUM_4W_349_4W_199',
	providers: {
		paltaMap: {
			USD: 'prd_vk1SG88uZkop',
		},
		primer: 'prd_vk1SG88uZkop',
	},
}
